/*
 * SPDX-FileCopyrightText: 2021 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { CursorPositionInfo } from './cursor-position-info'
import { NumberOfLinesInDocumentInfo } from './number-of-lines-in-document-info'
import { RemainingCharactersInfo } from './remaining-characters-info'
import { SelectedCharacters } from './selected-characters'
import { SelectedLines } from './selected-lines'
import { SeparatorDash } from './separator-dash'
import React from 'react'
import { WordCount } from './word-count'
import { FormatCheckerButton } from '../tool-bar/format-checker/format-checker-button'

/**
 * Shows additional information about the document length and the current selection.
 */
export const StatusBar: React.FC = () => {
  return (
    <div className={`gap-3 px-1 d-flex flex-row justify-content-between border-secondary border-top bg-light`}>
      <div>
        <CursorPositionInfo />
        <SelectedCharacters />
        <SelectedLines />
      </div>
      <div>
        <FormatCheckerButton />
      </div>
      <div>
        <NumberOfLinesInDocumentInfo />
        <SeparatorDash />
        <RemainingCharactersInfo />
        <SeparatorDash />
        <WordCount />
      </div>
    </div>
  )
}
